import React from 'react';
import { Award, Users, Target, Shield } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Iskustvo',
      description: 'Više od 15 godina uspješnog poslovanja u različitim sektorima.'
    },
    {
      icon: Users,
      title: 'Stručni tim',
      description: 'Tim od 50+ profesionalaca posvećenih vašem uspjehu.'
    },
    {
      icon: Target,
      title: 'Preciznost',
      description: 'Fokusirani na detaljnu izvedbu svakog projekta.'
    },
    {
      icon: Shield,
      title: 'Pouzdanost',
      description: 'Vaš siguran partner za sve poslovne potrebe.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-amber-600 font-semibold text-sm uppercase tracking-wide">O nama</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Zašto odabrati TDM DRAGON?
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            TDM DRAGON promet d.o.o. je vodećа kompanija koja pruža širok spektar profesionalnih 
            usluga. Naša misija je pružiti vrhunsku kvalitetu i pouzdanost u svim aspektima poslovanja.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group p-6 rounded-xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:border-amber-200 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-amber-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-amber-600 transition-colors duration-300">
                  <Icon className="text-amber-600 group-hover:text-white transition-colors duration-300" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;